'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarHeader = function BarHeader(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        title = props.title,
        subtitle = props.subtitle,
        theme = props.theme,
        dataTn = props.dataTn;


    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.headerWrapper },
        _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-title' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.title, theme[size])
            },
            title
        ),
        subtitle && _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-subtitle' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.subtitle, theme[size])
            },
            subtitle
        ),
        _react2.default.createElement('div', { className: theme.bottomBorder })
    );
};

BarHeader.displayName = 'BarHeader';

exports.default = BarHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/BarHeader/index.js
// module id = ./node_modules/dibs-elements/lib/BarHeader/index.js
// module chunks = 4